export default __webpack_public_path__ + "static/hw_ff_ds18b20_schem-77143308993bf7bf81c024fb3c02e911.png";